import { render, staticRenderFns } from "./UserClaims.vue?vue&type=template&id=70d93a6d&"
import script from "./UserClaims.vue?vue&type=script&lang=js&"
export * from "./UserClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports